export const MIN_ORDER_PRICE = 8.0;
export const LANGUAGES = {
  sq: "sq",
  en: "en"
};
